import React from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { ErrorScreen } from './ErrorScreen';

export function RouteErrorBoundary() {
	const routeError = useRouteError();

	const error =
		routeError instanceof Error
			? routeError
			: isRouteErrorResponse(routeError)
			? new Error(`${routeError.status} ${routeError.statusText}`)
			: new Error(String(routeError));

	if (process.env.APP_ENV === 'Local') {
		console.error('RouteErrorBoundary caught:', routeError);
	}

	return <ErrorScreen error={error} resetErrorBoundary={() => window.location.reload()} />;
}
